<div class="common__ownership--card--view">
  <div class="common__ownership--card--view--header h-[58.56px]">
    <div class="flex items-center">
      <span class="app__form--attribute--title text-[16px] leading-[24px] text-[#010B18]">
        {{ title }}
      </span>
    </div>

    <div class="app__attribute--dialog app__centered-item leading-[21px] gap-1" *ngIf="hasAutoAddSetting">
      <mat-slide-toggle
        [class.custom-disabled-toggle]="isRemoveEditSaveSharing"
        [checked]="userSettingPreference"
        [disabled]="isRemoveEditSaveSharing"
        (change)="!isRemoveEditSaveSharing && onToggleChange($event.checked)"
      >
      </mat-slide-toggle>
      <span class="app__form--attribute--title font-medium text-[12px] text-[#515765]"> Auto-Add </span>
    </div>
  </div>

  @if(canCreateNew) {
  <span class="w-full mt-[-16px]">
    <manage-templates
      [data]="allUserInstanceForms"
      [isInputFullWidth]="true"
      [isPositionValueShown]="true"
      [placeHolder]="searchBoxPlaceHolder"
      [selectedTemplate]="linkedItems"
      [hub_vault_user_form_id]="1"
      [disableSearch]="isRemoveEditSaveSharing"
      (selectionChange)="onItemSelectionChange($event)"
    ></manage-templates>
  </span>
  } @if(processedRecords.length > 0) {
  <div
    class="max-h-[283.5px] overflow-x-auto overflow-y-auto"
    [class]="
      (summaryData.hasSummary && processedRecords.length > 3) || (!summaryData.hasSummary && processedRecords.length > 4)
        ? 'w-[calc(100%+8px)] pr-2'
        : 'w-full pr-0'
    "
  >
    <div class="common__ownership--table--wrapper">
      <table class="common__ownership--table">
        <thead>
          <tr class="header-row">
            <th *ngIf="showSelection" class="checkbox-header">
              <mat-checkbox
                class="app__common--multiple--selection--checkbox"
                [(ngModel)]="selectAll"
                [disabled]="isRemoveEditSaveSharing"
                (change)="!isRemoveEditSaveSharing && onSelectAllChange($event.checked); $event.stopPropagation()"
              ></mat-checkbox>
            </th>
            <th *ngFor="let column of tableConfig?.columns" [ngClass]="{ 'text-left pl-4': column.text_align === 'left' }">
              {{ column.column_label }}
            </th>
            <th *ngIf="showActions" class="actions-header"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let processedRow of processedRecords; trackBy: trackRowBy"
            [class.cursor-pointer]="processedRow.record?.vault_user_form_user_id && processedRow.record?.writeAccess"
            (click)="processedRow.record?.writeAccess && onCellDataClick(processedRow.record); $event.stopPropagation()"
          >
            <td *ngIf="showSelection" class="checkbox-cell" (click)="$event.stopPropagation()">
              <mat-checkbox
                class="app__common--multiple--selection--checkbox"
                [(ngModel)]="processedRow.selected"
                [disabled]="isRemoveEditSaveSharing"
                (change)="!isRemoveEditSaveSharing && onRowSelectionChange(processedRow.index, $event.checked)"
              ></mat-checkbox>
            </td>
            <td
              *ngFor="let column of tableConfig?.columns; trackBy: trackColumnBy"
              class="table-cell"
              [class.text-center]="column.text_align === 'center'"
            >
              <ng-container [ngSwitch]="column.column_type">
                <div *ngSwitchCase="'percentage'" class="percentage-value w-full">
                  {{ processedRow.cells[column.column_id] }}
                </div>
                <span *ngSwitchCase="'currency'" class="currency-value w-full">
                  {{ processedRow.cells[column.column_id] }}
                </span>
                <span *ngSwitchCase="'text'">
                  {{ processedRow.cells[column.column_id] }}
                </span>
              </ng-container>
            </td>
            <td *ngIf="showActions" class="actions-cell" (click)="$event.stopPropagation()">
              <button
                class="action-btn hover:bg-transparent"
                [matMenuTriggerFor]="!isRemoveEditSaveSharing ? rowMenu : null"
                [disabled]="isRemoveEditSaveSharing"
                [ngClass]="{ 'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing }"
              >
                <span class="material-icons" [ngClass]="{ 'text-[#C1C2C5]': isRemoveEditSaveSharing }">more_vert</span>
              </button>
              <mat-menu #rowMenu="matMenu" yPosition="below" xPosition="after" class="popup-menu-panel">
                <ng-container *ngIf="processedRow">
                  <!-- <button
                    *ngFor="let actionData of formattedRowActions"
                    mat-menu-item
                    class="family__tree--popup--menuitem"
                    [class]="actionData.menuClass"
                    (click)="onRowActionHandler(processedRow, actionData, $event)"
                  >
                    <span class="material-icons menuitem-icon material-symbols-outlined text-xl" [class]="actionData.iconClass">
                      {{ actionData.icon }}
                    </span>
                    {{ actionData.label }}
                  </button> -->
                  <button
                    mat-menu-item
                    class="family__tree--popup--menuitem text-[#EB5757]"
                    (click)="onRowActionHandler(processedRow, { action: 'delete' }, $event)"
                  >
                    <span class="material-icons menuitem-icon material-symbols-outlined text-xl text-[#EB5757]"> delete </span>
                    Delete
                  </button>
                </ng-container>
              </mat-menu>
            </td>
          </tr>
        </tbody>

        <tfoot *ngIf="summaryData.hasSummary">
          <tr class="summary-row">
            <td *ngIf="showSelection" class="summary-cell"></td>
            <td *ngFor="let column of tableConfig?.columns; let colIndex = index" class="summary-cell">
              <ng-container *ngIf="colIndex === 0">
                <span class="summary-label">{{ summaryData.summaryLabel }}</span>
              </ng-container>
              <ng-container *ngIf="colIndex > 0">
                <ng-container [ngSwitch]="column.column_type">
                  <span *ngSwitchCase="'currency'" class="summary-value">
                    {{ summaryData.summaryValues[column.column_id] }}
                  </span>
                  <span *ngSwitchCase="'percentage'" class="summary-value">
                    {{ summaryData.summaryValues[column.column_id] }}
                  </span>
                  <span *ngSwitchDefault></span>
                </ng-container>
              </ng-container>
            </td>
            <td *ngIf="showActions" class="summary-cell"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
  } @else {
  <div class="common__ownership--empty--state">
    <span class="app__form--attribute--title flex items-center text-sm font-semibold gap-2">
      <img [src]="'assets/images/linked-' + categoryKey + '-empty-state.svg'" alt="empty-state" />
      <span class="text-[14px] leading-[20px] text-[#707070]"
        >No <span class="text-[#25508E]"> {{ categoryKey | capitalizeFirstWord }}</span> to show</span
      >
    </span>
  </div>
  }
</div>
